var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalculatorinline = function SvgCalculatorinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#calculator_inline_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.638.001a3.82 3.82 0 0 1 3.818 3.818v20.364A3.82 3.82 0 0 1 21.638 28H6.365a3.82 3.82 0 0 1-3.818-3.818V3.819A3.82 3.82 0 0 1 6.365.001zM6.365 3.819h15.273v7.637H6.365zm8.91 11.455v2.558h-2.546v-2.558zm0 5.09h-2.546v2.559h2.545zm-5.092 0v2.559H7.638v-2.558zm10.182 0H17.82v2.559h2.545zm0-5.09v2.558H17.82v-2.558zm-10.182 0H7.638v2.558h2.545z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "calculator_inline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })))));
};
export default SvgCalculatorinline;